import { parseMoney } from '../utils/money';

const BASE_URL = 'https://sistema.hoprinplus.com/api/v1/suite';
const API_KEY = process.env.REACT_APP_SISTEMA_API_KEY || 'FALLBACK_KEY';

const roundMoney = (value) => parseMoney(value) ?? 0;

const request = async (path, options = {}) => {
    try {
        const response = await fetch(`${BASE_URL}${path}`, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                'X-Suite-Api-Key': API_KEY,
                ...options.headers
            }
        });
        if (!response.ok) throw new Error(`El puente Sistema respondió HTTP ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error(`Error en puente Sistema (${path}):`, error);
        throw error;
    }
};

export const fetchSistemaMetrics = async (year, month) => {
    try {
        const data = await request(`/metrics/summary?year=${year}&month=${month}`);
        const series = data.series_anuales || {};
        return {
            ...data,
            tasa_usd: roundMoney(data.tasa_usd) || 0,
            ingresos_mes: roundMoney(data.ingresos_mes),
            gastos_sistema_mes: roundMoney(data.gastos_sistema_mes),
            proximos_vencimientos_30d: roundMoney(data.proximos_vencimientos_30d),
            series_anuales: {
                ...series,
                ingresos: (series.ingresos || []).map(roundMoney),
                gastos: (series.gastos || []).map(roundMoney)
            }
        };
    } catch (error) {
        throw error;
    }
};

export const fetchSistemaInventory = async () => {
    try {
        const data = await request('/inventory/sync');
        const inventory = data.data || data;
        const roundStock = (item) => ({
            ...item,
            unidades: roundMoney(item.unidades ?? item.unidades_disponibles),
            punto_de_reorden: roundMoney(item.punto_de_reorden)
        });
        return {
            ...inventory,
            stock_perfiles: (inventory.stock_perfiles || []).map(roundStock),
            stock_cuentas: (inventory.stock_cuentas || []).map(roundStock),
            cuentas: inventory.cuentas || inventory.cuentas_sincronizadas || []
        };
    } catch (error) {
        throw error;
    }
};

export const fetchValidationTransactions = async () => {
    try {
        const data = await request('/validation/transactions');
        const transactions = data.data || data;
        return transactions.map((transaction) => ({
            ...transaction,
            amount: roundMoney(transaction.amount)
        }));
    } catch (error) {
        throw error;
    }
};

export const updateValidationTransaction = async (id, payload) => {
    try {
        const data = await request(`/validation/transactions/${id}`, {
            method: 'PATCH',
            body: JSON.stringify(payload)
        });
        return { ...(data.data || data), amount: roundMoney((data.data || data).amount) };
    } catch (error) {
        throw error;
    }
};
